import { CompanySetupService } from './../../../../app/pages/company-setup/company-setup.service';
import { Component, Input, Output, EventEmitter, ElementRef, HostListener, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MissionClientService } from '@rsm/client/mission-client';
import { AgenteClientService } from '@rsm/client/agente-client';
import { AuthClientService } from '@rsm/client/auth-client';
import { SecurityService } from '@rsm/shared/security';
import { MessageService } from '@rsm/shared/message';
import { catchError, forkJoin, of, Subscription } from 'rxjs';
import { ProfilePhotoStoreService } from 'src/app/core/profile-photo/profile-photo-store.service';

interface GlobalSearchResult {
  title: string;
  category: string;
  route: string;
  iconClass: string;
  colorClass: string;
  contexts: string[];
  rootOnly?: boolean;
}

interface TopbarCompanyOption {
  id: string;
  contextId: string;
  userContextId: string;
  name: string;
  planName: string;
  active: boolean;
}

@Component({
  selector: 'rsm-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {
  @Input() userName = '';
  @Output() logout = new EventEmitter<void>();
  currentPage = 'Home';
  unreadNotificationsCount = 3;
  globalSearchTerm = '';
  searchFocused = false;
  selectedSearchContext = 'Geral';
  currentCompanyName = 'Empresa';
  companyOptions: TopbarCompanyOption[] = [];
  switchingContext = false;

  searchContexts = [
    'Geral',
    'Campanhas',
    'Usuários',
    'Empresas',
    'Notificações',
    'Meu Perfil',
    'Configuração',
    'Gestão'
  ];
  readonly searchResultsIndex: GlobalSearchResult[] = [
    {
      title: 'Campanhas',
      category: 'Telas e Módulos',
      route: '/campaigns',
      iconClass: 'fa-solid fa-bullhorn',
      colorClass: 'text-orange',
      contexts: ['Campanhas'],
    },
    {
      title: 'Listagem de usuários',
      category: 'Telas e Módulos',
      route: '/users',
      iconClass: 'fa-solid fa-users',
      colorClass: 'text-blue',
      contexts: ['Usuários', 'Gestão'],
    },
    {
      title: 'Cadastro de novo usuário',
      category: 'Telas e Módulos',
      route: '/users/new-user',
      iconClass: 'fa-solid fa-user-plus',
      colorClass: 'text-blue',
      contexts: ['Usuários', 'Gestão'],
    },
    {
      title: 'Empresas',
      category: 'Configurações',
      route: '/company-details',
      iconClass: 'fa-solid fa-building',
      colorClass: 'text-gray',
      contexts: ['Empresas', 'Configuração'],
    },
    {
      title: 'Campos',
      category: 'Configurações',
      route: '/management/fields',
      iconClass: 'fa-solid fa-sliders',
      colorClass: 'text-green',
      contexts: ['Configuração', 'Gestão'],
      rootOnly: true,
    },
    {
      title: 'Perfis de gestão',
      category: 'Telas e Módulos',
      route: '/management/profiles',
      iconClass: 'fa-solid fa-id-card',
      colorClass: 'text-purple',
      contexts: ['Gestão'],
      rootOnly: true,
    },
    {
      title: 'Módulos de gestão',
      category: 'Telas e Módulos',
      route: '/management/modules',
      iconClass: 'fa-solid fa-cubes',
      colorClass: 'text-purple',
      contexts: ['Gestão', 'Configuração'],
      rootOnly: true,
    },
    {
      title: 'Módulo: Campanhas',
      category: 'Registros de Módulos',
      route: '/management/modules',
      iconClass: 'fa-solid fa-cube',
      colorClass: 'text-purple',
      contexts: ['Gestão', 'Configuração', 'Campanhas'],
      rootOnly: true,
    },
    {
      title: 'Módulo: Usuários',
      category: 'Registros de Módulos',
      route: '/management/modules',
      iconClass: 'fa-solid fa-cube',
      colorClass: 'text-purple',
      contexts: ['Gestão', 'Configuração', 'Usuários'],
      rootOnly: true,
    },
    {
      title: 'Módulo: Empresas',
      category: 'Registros de Módulos',
      route: '/management/modules',
      iconClass: 'fa-solid fa-cube',
      colorClass: 'text-purple',
      contexts: ['Gestão', 'Configuração', 'Empresas'],
      rootOnly: true,
    },
    {
      title: 'Módulo: Configuração',
      category: 'Registros de Módulos',
      route: '/management/modules',
      iconClass: 'fa-solid fa-cube',
      colorClass: 'text-purple',
      contexts: ['Gestão', 'Configuração'],
      rootOnly: true,
    },
    {
      title: 'Revisões',
      category: 'Telas e Módulos',
      route: '/management/reviews',
      iconClass: 'fa-solid fa-file-lines',
      colorClass: 'text-purple',
      contexts: ['Gestão'],
    },
    {
      title: 'Revisão biométrica',
      category: 'Telas e Módulos',
      route: '/management/reviews',
      iconClass: 'fa-solid fa-user-check',
      colorClass: 'text-purple',
      contexts: ['Gestão'],
    },
    {
      title: 'Parametrização de pontos',
      category: 'Configurações',
      route: '/management/points',
      iconClass: 'fa-solid fa-coins',
      colorClass: 'text-purple',
      contexts: ['Gestão', 'Pontos', 'Configuração'],
      rootOnly: true,
    },
    {
      title: 'Usuários da gestão',
      category: 'Telas e Módulos',
      route: '/management/users',
      iconClass: 'fa-solid fa-user-gear',
      colorClass: 'text-purple',
      contexts: ['Gestão', 'Usuários'],
      rootOnly: true,
    },
    {
      title: 'Notificações',
      category: 'Telas e Módulos',
      route: '/notifications',
      iconClass: 'fa-solid fa-bell',
      colorClass: 'text-orange',
      contexts: ['Notificações'],
    },
    {
      title: 'Meu perfil',
      category: 'Telas e Módulos',
      route: '/profile',
      iconClass: 'fa-solid fa-user',
      colorClass: 'text-blue',
      contexts: ['Meu Perfil'],
    },
  ];
  campaignResults: GlobalSearchResult[] = [];
  userResults: GlobalSearchResult[] = [];
  companyResults: GlobalSearchResult[] = [];
  private campaignSearchTimeout: any;
  private readonly campaignResultsCache = new Map<string, GlobalSearchResult[]>();
  private readonly userResultsCache = new Map<string, GlobalSearchResult[]>();
  private readonly companyResultsCache = new Map<string, GlobalSearchResult[]>();
  private companyCatalogLoaded = false;
  private companyCatalogLoading = false;
  private companyCatalog: Array<{ title: string; route: string }> = [];
  private activeSearchToken = 0;
  private profilePhotoSubscription?: Subscription;
  profilePhoto: string | null = null;

  currentUser : any;

  get userInitial(): string {
    return this.userName ? this.userName.substring(0, 1).toUpperCase() : 'U';
  }

  get activeCompanyOption(): TopbarCompanyOption | undefined {
    return this.companyOptions.find(c => c.active);
  }

  get inactiveCompanyOptions(): TopbarCompanyOption[] {
    return this.companyOptions.filter(c => !c.active);
  }

  // --- Emulação de produto (somente RSM) -----------------------------------
  //
  // O plano ROOT é neutro: não herda o comportamento de nenhum produto. Para
  // operar e dar suporte dentro de um produto, a RSM declara qual chapéu está
  // usando. O seletor fica no menu da empresa por ser onde o operador já olha
  // para saber "em que conta estou".

  readonly emulationOptions: Array<{ code: string | null; label: string }> = [
    { code: null, label: 'Nenhum (administrativo)' },
    { code: 'POLITICS', label: 'RSM Politics' },
    { code: 'DEDICATED', label: 'RSM Dedicada' },
    { code: 'CAMPAIGNS', label: 'RSM Campanhas' },
  ];

  /** Produto emulado hoje; `null` = root neutro. */
  emulatedProductType: string | null = null;
  emulationAvailable = false;
  switchingEmulation = false;

  get isRootContext(): boolean {
    return this.securityService.isRootContext;
  }

  get emulatedProductLabel(): string {
    const option = this.emulationOptions.find(o => o.code === this.emulatedProductType);
    return option ? option.label : 'Nenhum (administrativo)';
  }

  /**
   * Troca o chapéu e recarrega a aplicação.
   *
   * <p>O reload é proposital, e não um atalho: o produto efetivo decide tema,
   * escopo de mural e regras de licença já resolvidos em telas abertas. Atualizar
   * só este menu deixaria o resto da sessão exibindo o produto anterior.</p>
   */
  setEmulatedProductType(code: string | null) {
    if (this.switchingEmulation || code === this.emulatedProductType) {
      return;
    }

    const contextId = `${this.securityService.credential.user?.contextId || ''}`;
    if (!contextId) {
      return;
    }

    this.switchingEmulation = true;
    this.missionService.updateEmulatedProductType(contextId, code).subscribe({
      next: () => window.location.reload(),
      error: () => {
        this.switchingEmulation = false;
        this.changeDetectorRef.detectChanges();
      },
    });
  }

  private loadEmulationState() {
    if (!this.isRootContext) {
      return;
    }

    const contextId = `${this.securityService.credential.user?.contextId || ''}`;
    if (!contextId) {
      return;
    }

    this.missionService
      .getCompanyProductType(contextId)
      .pipe(catchError(() => of(null)))
      .subscribe((productType) => {
        if (!productType) {
          return;
        }
        // Só oferece o seletor a quem de fato tem plano ROOT. `isRoot` no token
        // vem do contexto, que pode estar marcado root sem o plano ter migrado;
        // nesse caso o servidor recusaria a troca e o menu prometeria algo que
        // não funciona.
        this.emulationAvailable = productType.actualProductType === 'ROOT';
        this.emulatedProductType = productType.rootEmulation
          ? productType.productType
          : null;
        this.changeDetectorRef.detectChanges();
      });
  }

  constructor(
    public router: Router,
    private eRef: ElementRef,
    private missionService: MissionClientService,
    private companySetupService: CompanySetupService,
    private agenteClientService: AgenteClientService,
    private authClientService: AuthClientService,
    private securityService: SecurityService,
    private profilePhotoStoreService: ProfilePhotoStoreService,
    private changeDetectorRef: ChangeDetectorRef,
    private messageService: MessageService
  ) {
    this.updateCurrentPage(this.router.url);
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.updateCurrentPage(event.urlAfterRedirects));
    this.loadCompanyOptions();
    this.loadEmulationState();
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') as string);
    this.profilePhoto = this.profilePhotoStoreService.getPhoto();
    this.profilePhotoSubscription = this.profilePhotoStoreService.photo$.subscribe((photo) => {
      this.profilePhoto = photo;
      this.changeDetectorRef.detectChanges();
    });
    this.profilePhotoStoreService.loadApprovedPhoto();
  }

  ngOnDestroy() {
    this.profilePhotoSubscription?.unsubscribe();
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    if (this.searchFocused && !this.eRef.nativeElement.contains(event.target)) {
      // Se clicar fora da topbar inteira, ou fora do dropdown (que é injetado no overlay), a gente fecha.
      // O mat-menu é injetado no final do body (.cdk-overlay-container), então precisamos checar
      // se o clique não foi lá dentro também.
      const isOverlayClick = (event.target as HTMLElement).closest('.cdk-overlay-container');
      if (!isOverlayClick) {
        this.searchFocused = false;
      }
    }
  }

  onSearchFocus() {
    this.searchFocused = true;
  }

  onSearchTermChange(value: string) {
    this.globalSearchTerm = value || '';
    if (!this.globalSearchTerm.trim()) {
      this.clearDynamicSearchResults();
      return;
    }

    this.refreshDynamicSearch();
  }

  onSearchContextChange(context: string) {
    this.selectedSearchContext = context;
    if (this.globalSearchTerm.trim()) {
      this.onSearchSubmit();
    }
  }

  onSearchSubmit() {
    this.searchFocused = true;
    this.refreshDynamicSearch();
  }

  clearSearch(event?: MouseEvent) {
    event?.stopPropagation();
    this.globalSearchTerm = '';
    this.clearDynamicSearchResults();
  }

  // Removemos o blur para não fechar acidentalmente ao clicar no botão
  onSearchBlur() {
    // O fechamento será tratado pelo HostListener ou pelo menu
  }

  onLogout() {
    this.logout.emit();
  }

  onSearchResultClick(route: string, event?: MouseEvent) {
    event?.preventDefault();
    event?.stopPropagation();
    this.router.navigateByUrl(route);
    this.searchFocused = false;
    this.globalSearchTerm = '';
  }

  get groupedSearchResults(): Array<{ category: string; items: GlobalSearchResult[] }> {
    const search = this.normalizeText(this.globalSearchTerm);
    if (!search) {
      return [];
    }

    const mergedResults = [
      ...this.searchResultsIndex,
      ...this.campaignResults,
      ...this.userResults,
      ...this.companyResults,
    ];
    const filtered = mergedResults.filter((item) => {
      if (!this.canShowSearchResult(item)) {
        return false;
      }

      const inContext =
        !this.selectedSearchContext ||
        this.selectedSearchContext === 'Geral' ||
        item.contexts.includes(this.selectedSearchContext);
      if (!inContext) {
        return false;
      }

      const haystack = this.normalizeText(
        `${item.title} ${item.category} ${item.contexts.join(' ')}`
      );
      return haystack.includes(search);
    });

    const groupedMap = new Map<string, GlobalSearchResult[]>();
    filtered.forEach((item) => {
      if (!groupedMap.has(item.category)) {
        groupedMap.set(item.category, []);
      }
      groupedMap.get(item.category)!.push(item);
    });

    return Array.from(groupedMap.entries()).map(([category, items]) => ({
      category,
      items,
    }));
  }

  get totalSearchResults(): number {
    return this.groupedSearchResults.reduce((acc, group) => acc + group.items.length, 0);
  }

  private normalizeText(value: string): string {
    return `${value || ''}`
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  private canShowSearchResult(item: GlobalSearchResult): boolean {
    return !item.rootOnly || this.securityService.isRootContext;
  }

  private refreshDynamicSearch() {
    clearTimeout(this.campaignSearchTimeout);
    const term = this.globalSearchTerm?.trim();
    if (!term) {
      this.clearDynamicSearchResults();
      return;
    }

    const shouldSearchCampaigns =
      this.selectedSearchContext === 'Geral' || this.selectedSearchContext === 'Campanhas';
    const shouldSearchUsers =
      this.selectedSearchContext === 'Geral' || this.selectedSearchContext === 'Usuários';
    const shouldSearchCompanies =
      this.selectedSearchContext === 'Geral' || this.selectedSearchContext === 'Empresas';
    const normalizedTerm = this.normalizeText(term);
    const searchToken = ++this.activeSearchToken;

    if (shouldSearchCampaigns) {
      this.campaignResults = this.getCachedResultsForTerm(
        this.campaignResultsCache,
        normalizedTerm
      );
    } else {
      this.campaignResults = [];
    }

    if (shouldSearchUsers) {
      this.userResults = this.getCachedResultsForTerm(
        this.userResultsCache,
        normalizedTerm
      );
    } else {
      this.userResults = [];
    }

    if (shouldSearchCompanies) {
      this.companyResults = this.getCachedResultsForTerm(
        this.companyResultsCache,
        normalizedTerm
      );
    } else {
      this.companyResults = [];
    }

    this.campaignSearchTimeout = setTimeout(() => {
      if (shouldSearchCampaigns) {
        this.loadCampaignResults(term, searchToken);
      } else {
        this.campaignResults = [];
      }

      if (shouldSearchUsers) {
        this.loadUserResults(term, searchToken);
      } else {
        this.userResults = [];
      }

      if (shouldSearchCompanies) {
        this.loadCompanyResults(term, searchToken);
      } else {
        this.companyResults = [];
      }
    }, 300);
  }

  private loadCampaignResults(term: string, searchToken: number) {
    const cacheKey = this.normalizeText(term);
    if (this.campaignResultsCache.has(cacheKey)) {
      this.campaignResults = this.campaignResultsCache.get(cacheKey) || [];
      return;
    }

    this.missionService
      .getCampaigns({
        page: 0,
        size: 25,
        idStatus: '',
        search: term,
        titleCampaign: term,
        name: term,
      })
      .pipe(catchError(() => of({ content: [] })))
      .subscribe((response: any) => {
        const content = Array.isArray(response?.content) ? response.content : [];
        const normalizedTerm = this.normalizeText(term);

        const results = content
          .filter((campaign: any) => {
            const title = this.normalizeText(this.getCampaignDisplayTitle(campaign));
            return title.includes(normalizedTerm);
          })
          .slice(0, 8)
          .map((campaign: any) => {
            const id = campaign?.idCampaign || campaign?.id;
            const route =
              campaign?.descriptionStatusCampaign === 'Rascunho'
                ? `/mission/${id}/edit`
                : `/mission/${id}`;

            return {
              title: this.getCampaignDisplayTitle(campaign),
              category: 'Registros de Campanhas',
              route,
              iconClass: 'fa-solid fa-bullhorn',
              colorClass: 'text-orange',
              contexts: ['Campanhas'],
            } as GlobalSearchResult;
          });

        this.campaignResultsCache.set(cacheKey, results);

        if (searchToken === this.activeSearchToken) {
          this.campaignResults = results;
        }
      });
  }

  private loadUserResults(term: string, searchToken: number) {
    const contextId = this.securityService.credential.user?.contextId;
    if (!contextId) {
      this.userResults = [];
      return;
    }

    const cacheKey = this.normalizeText(term);
    if (this.userResultsCache.has(cacheKey)) {
      this.userResults = this.userResultsCache.get(cacheKey) || [];
      return;
    }

    this.agenteClientService
      .getAllAgentsByFilter(contextId, {
        page: 0,
        size: 10,
        idStatus: '',
        name: term,
      } as any)
      .pipe(catchError(() => of({ content: [] })))
      .subscribe((response: any) => {
        const content = Array.isArray(response?.content) ? response.content : [];
        const normalizedTerm = this.normalizeText(term);

        const results = content
          .filter((user: any) => {
            const haystack = this.normalizeText(
              `${user?.name || ''} ${user?.email || ''} ${user?.profileDescripiton || ''} ${user?.statusDescription || ''}`
            );
            return haystack.includes(normalizedTerm);
          })
          .slice(0, 8)
          .map((user: any) => ({
            title: `${user?.name || 'Usuário'}${user?.email ? ` - ${user.email}` : ''}`,
            category: 'Registros de Usuários',
            route: user?.userId ? `/users/${user.userId}` : '/users',
            iconClass: 'fa-solid fa-user',
            colorClass: 'text-blue',
            contexts: ['Usuários', 'Gestão'],
          }));

        this.userResultsCache.set(cacheKey, results);

        if (searchToken === this.activeSearchToken) {
          this.userResults = results;
        }
      });
  }

  private loadCompanyResults(term: string, searchToken: number) {
    const cacheKey = this.normalizeText(term);
    if (this.companyResultsCache.has(cacheKey)) {
      this.companyResults = this.companyResultsCache.get(cacheKey) || [];
      return;
    }

    if (this.companyCatalogLoaded) {
      const results = this.filterCompanyCatalog(term);
      this.companyResultsCache.set(cacheKey, results);
      if (searchToken === this.activeSearchToken) {
        this.companyResults = results;
      }
      return;
    }

    if (this.companyCatalogLoading) {
      return;
    }

    this.companyCatalogLoading = true;
    this.authClientService
      .findAllContexts()
      .pipe(
        catchError(() => of([])),
      )
      .subscribe((contexts: any[]) => {
        const requests = (contexts || []).map((context: any) =>
          this.companySetupService.getCompanyByContextId(context.id).pipe(
            catchError(() => of(null))
          )
        );

        if (!requests.length) {
          this.companyCatalog = [];
          this.companyCatalogLoaded = true;
          this.companyCatalogLoading = false;
          return;
        }

        forkJoin(requests).subscribe((companies: any[]) => {
          this.companyCatalog = (companies || [])
            .filter((company: any) => !!company)
            .map((company: any) => ({
              title:
                `${company?.fantasyName || company?.name || company?.razaoSocial || company?.fantasia || 'Empresa'}`.trim(),
              route: '/company-details',
            }))
            .filter((company) => !!company.title);

          this.companyCatalogLoaded = true;
          this.companyCatalogLoading = false;

          const results = this.filterCompanyCatalog(term);
          this.companyResultsCache.set(cacheKey, results);
          if (searchToken === this.activeSearchToken) {
            this.companyResults = results;
          }
        });
      });
  }

  private clearDynamicSearchResults() {
    this.campaignResults = [];
    this.userResults = [];
    this.companyResults = [];
  }

  private getCachedResultsForTerm(
    cache: Map<string, GlobalSearchResult[]>,
    normalizedTerm: string
  ): GlobalSearchResult[] {
    const exactMatch = cache.get(normalizedTerm);
    if (exactMatch) {
      return exactMatch;
    }

    let closestCachedTerm = '';
    for (const cachedTerm of cache.keys()) {
      if (
        normalizedTerm.startsWith(cachedTerm) &&
        cachedTerm.length > closestCachedTerm.length
      ) {
        closestCachedTerm = cachedTerm;
      }
    }

    if (!closestCachedTerm) {
      return [];
    }

    const baseResults = cache.get(closestCachedTerm) || [];
    return baseResults.filter((item) =>
      this.normalizeText(`${item.title} ${item.category} ${item.contexts.join(' ')}`).includes(
        normalizedTerm
      )
    );
  }

  private getCampaignDisplayTitle(campaign: any): string {
    const rawTitle =
      campaign?.title ??
      campaign?.titleCampaign ??
      campaign?.name ??
      campaign?.descriptionCampaign ??
      '';
    const title = `${rawTitle}`.trim();

    if (!title) {
      return `Campanha ${campaign?.idCampaign || campaign?.id || ''}`.trim();
    }

    // Evita exibir identificadores técnicos quando não houver título amigável.
    const looksLikeUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(title);
    if (looksLikeUuid) {
      const fallback = `${campaign?.descriptionCampaign || ''}`.trim();
      return fallback || `Campanha ${campaign?.idCampaign || campaign?.id || ''}`.trim();
    }

    return title;
  }

  private filterCompanyCatalog(term: string): GlobalSearchResult[] {
    const normalizedTerm = this.normalizeText(term);
    return this.companyCatalog
      .filter((company) => this.normalizeText(company.title).includes(normalizedTerm))
      .slice(0, 8)
      .map((company) => ({
        title: company.title,
        category: 'Registros de Empresas',
        route: company.route,
        iconClass: 'fa-solid fa-building',
        colorClass: 'text-gray',
        contexts: ['Empresas', 'Configuração'],
      }));
  }

  onMenuOpened() {
    // Nomes e planos ja foram carregados no load (findAllContexts + 1 chamada
    // de lote). Abrir o menu nao dispara mais nenhuma requisicao — abre instantaneo.
  }

  private loadCompanyOptions() {
    const currentContextId = `${this.securityService.credential.user?.contextId || ''}`;

    this.authClientService
      .findAllContexts()
      .pipe(catchError(() => of([])))
      .subscribe((contexts: any[]) => {
        const list = contexts || [];

        if (!list.length) {
          this.companyOptions = [];
          this.currentCompanyName = 'Empresa';
          return;
        }

        const activeContext =
          list.find((c: any) => `${c.id}` === currentContextId) || list[0];

        // O nome ja vem do findAllContexts (context.name = nome fantasia da
        // empresa, definido na criacao) — nao precisa de 1 request por empresa
        // so para o nome. Renderiza imediato; so o plano exige chamada.
        this.companyOptions = list.map((c: any) => ({
          id: c.id,
          contextId: `${c.id}`,
          userContextId: c.userContextId || '',
          name: c.name || 'Empresa',
          planName: '',
          active: `${c.id}` === currentContextId,
        }));

        // Nome do ativo ja veio do contexto; mostra imediato.
        this.currentCompanyName = activeContext.name || 'Empresa';

        // Uma UNICA chamada de lote traz o plano de TODAS as empresas de vez
        // (antes: 1 request por empresa = N+1, o que deixava o menu lento).
        const contextIds = list.map((c: any) => `${c.id}`);
        this.companySetupService
          .getCompanyPlanSummaries(contextIds)
          .pipe(catchError(() => of([] as Array<{ contextId: string; planName: string }>)))
          .subscribe((summaries) => {
            const planByContext = new Map<string, string>();
            (summaries || []).forEach((s) =>
              planByContext.set(`${s.contextId}`, s.planName || '')
            );
            this.companyOptions = this.companyOptions.map((opt) => ({
              ...opt,
              planName: planByContext.get(`${opt.contextId}`) || '',
            }));
          });
      });
  }

  private updateCurrentPage(url: string) {
    if (url === '/' || url.startsWith('/home')) {
      this.currentPage = 'Home';
      return;
    }

    if (url.startsWith('/campaigns')) {
      this.currentPage = 'Campanhas';
      return;
    }

    if (url.includes('/users/new-user')) {
      this.currentPage = 'Novo Usuário';
      return;
    }

    if (url.includes('/users')) {
      this.currentPage = 'Usuários';
      return;
    }

    if (url.includes('/mission')) {
      this.currentPage = 'Campanhas';
      return;
    }

    if (url.startsWith('/company-details')) {
      this.currentPage = 'Empresas';
      return;
    }

    if (url.startsWith('/settings/fields')) {
      this.currentPage = 'Gestão';
      return;
    }

    if (url.startsWith('/management')) {
      this.currentPage = 'Gestão';
      return;
    }

    if (url.startsWith('/profile')) {
      this.currentPage = 'Meu Perfil';
      return;
    }

    if (url.startsWith('/notifications')) {
      this.currentPage = 'Notificações';
      return;
    }

    this.currentPage = 'Home';
  }

  goToNewCompany(){
      this.agenteClientService.validHasEmail(this.currentUser.id).subscribe(res => {
        if(res){
        this.companySetupService.currentComponentIndex.next(0);
        this.companySetupService.companyId = undefined;
        this.companySetupService.contextId = undefined;
        this.companySetupService.companyType = undefined;
        this.router.navigateByUrl('/company-setup')
        } else {
          this.router.navigate(['/corporate-email']);
        }
      })

  }

  /**
   * Troca o contexto ativo para a empresa selecionada na lista.
   * Só executa se a empresa não for o contexto atual.
   */
  public switchCompanyContext(option: TopbarCompanyOption): void {
    if (option.active || this.switchingContext || !option.userContextId) return;
    // A trava por plano é pra quem tá trocando de empresa como uma empresa comum.
    // A RSM Root enxerga e acessa qualquer empresa pra dar suporte, independente
    // do plano dela — é o próprio motivo da conta root existir.
    if (!option.planName && !this.isRootContext) {
      this.messageService.addMsgWarning({ message: `${option.name} não possui plano ativo. Não é possível acessar.` });
      return;
    }
    this.switchingContext = true;

    const refreshToken = this.securityService.credential?.refreshToken
      || this.currentUser?.refreshToken;

    this.authClientService.refresh({ refreshToken, userContextId: option.userContextId })
      .subscribe({
        next: (data: any) => {
          // Salva as novas credenciais no storage/serviço antes do reload
          this.securityService.init({
            id: data.userId,
            name: data.name,
            login: data.login,
            email: data.email,
            roles: data.roles,
            profile: data.profile,
            context: data.context,
            contextId: data.contextId,
            isRoot: data.isRoot,
            accessToken: data.accessToken,
            expiresIn: data.accessExpiresIn,
            refreshToken: data.refreshToken,
            userContextId: data.userContextId,
            expiredPassword: data.temporaryPassword,
          });
          // Hard reload — reinicializa todos os serviços Angular com o novo
          // contexto. router.navigate(['/']) não basta pois o app já está em '/'
          // e os interceptors HTTP continuariam usando o token antigo em memória.
          window.location.href = '/';
        },
        error: () => {
          this.switchingContext = false;
          this.router.navigate(['/access/context']);
        },
      });
  }

}
